import error from './error';
import status from './status';

export default {
  error,
  status,
};
